import { ICompany } from 'features/Companies/types'
import { ICompanyLine } from 'features/Lines/types'
import { IPlace } from 'features/Places/types'

export interface IAddress {
  line1: string
  line2: string
  city: string
  zipCode: string
  stateCode: string
}

export enum EPaymentMethod {
  CASH = 'CASH',
  CARD = 'CARD',
  RESERVED = 'reserved',
  MIXED = 'mixed'
}

export interface ISnacks {
  canSell: boolean
  showMinPrice: boolean
  tripRequired: boolean
}

export interface IKredits {
  canTopUp: boolean
}
export interface ISettings {
  payment: EPaymentMethod[]
  canReserveTickets: boolean
  snacks: ISnacks
  kredits: IKredits
  defaultOrigin: Pick<IPlace, 'id' | 'name'>
  passengerNameRequired: boolean
  hasPrinter: boolean
  canChangePrice: boolean
  saleClosingThreshold: number
  enabledCompanyLines: Pick<ICompanyLine, 'id' | 'name'>[]
  enableMixedPayments: boolean
  hideTransactionsReport: boolean
}

export interface IUsers {
  id: string
  username: string
  firstName: string
  lastName: string
}

export interface ISite {
  id?: string
  company?: Pick<ICompany, 'id' | 'name'>
  address?: IAddress
  settings?: ISettings
  name?: string
  type?: string
  users?: IUsers[]
}
